(() => {
  'use strict';
  const page = document.querySelector('[data-commercial-page]');
  const form = document.getElementById('commercial-quote');
  if (!page || !form || page.dataset.quoteReady) return;
  page.dataset.quoteReady = 'true';
  const track = (event, values = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...values });
  };
  track('commercial_page_view');
  window.addEventListener('load', () => {
    const events = Array.isArray(window.dataLayer) ? window.dataLayer : [];
    if (!events.some(entry => entry?.event === 'commercial_page_view')) track('commercial_page_view');
  }, { once: true });
  const receiptKey = 'ozbee-quote-receipt';
  const success = form.querySelector('[data-quote-success]');
  if (success) {
    try {
      const receipt = JSON.parse(sessionStorage.getItem(receiptKey) || 'null');
      sessionStorage.removeItem(receiptKey);
      if (receipt) track('quote_request_submitted', {
        hive_count: receipt.hive_count,
        item_count: receipt.item_count,
        delivery_town_type: receipt.delivery_town_type,
        needed_by: receipt.needed_by
      });
    } catch (_) { /* Storage may be disabled; do not fabricate conversion data. */ }
    success.scrollIntoView({ block: 'center' });
    success.focus({ preventScroll: true });
    return;
  }

  const steps = [...form.querySelectorAll('[data-quote-step]')];
  const checks = [...form.querySelectorAll('[data-item-check]')];
  const cards = [...page.querySelectorAll('[data-quote-key]')];
  const heroes = [...page.querySelectorAll('[data-hero-hives]')];
  const radios = [...form.querySelectorAll('input[name="contact[Hive count]"]')];
  const progress = form.querySelector('[data-quote-progress]');
  const errors = form.querySelector('[data-quote-errors]');
  const back = form.querySelector('[data-quote-back]');
  const next = form.querySelector('[data-quote-next]');
  const submit = form.querySelector('[data-quote-submit]');
  const sticky = page.querySelector('[data-sticky-quote]');
  const ratios = { 'beetle-traps': 2, 'top-feeders': 1, excluders: 1, 'bottom-boards': 1, 'varroa-treatments': 1, frames: 20 };
  const field = name => form.elements.namedItem(`contact[${name}]`);
  const value = name => field(name)?.value || '';
  const checked = () => checks.filter(check => check.checked);
  let current = 0;
  let heroPast = false;
  let formVisible = false;

  function updateSticky() {
    sticky.hidden = !(heroPast && !formVisible);
  }
  function summary() {
    const parts = [`${value('Hive count')} hives, ${value('Hive size')}`];
    checked().forEach(check => {
      const item = check.closest('[data-quote-item]');
      const quantity = item.querySelector('input[type="number"]').value;
      const key = check.dataset.itemCheck;
      let text = `${check.nextElementSibling.textContent}: ${quantity || 'please advise'}`;
      if (key === 'bottom-boards') text += ` (${value('Bottom board size') || 'size not selected'})`;
      if (key === 'varroa-treatments') text = `Varroa: ${quantity || 'please advise'} hives (${value('Varroa treatment') || 'treatment not selected'})`;
      if (key === 'frames') text += ` (${value('Frame type')}, ${value('Frame depth')})`;
      parts.push(text);
    });
    if (value('Other items')) parts.push(`Other items: ${value('Other items')}`);
    parts.push(`${value('Delivery town')}, ${value('Delivery or pickup')}, ${value('Needed by')}`);
    form.querySelector('[data-quote-summary]').value = parts.join(' | ');
  }
  function suggest() {
    const lower = parseInt(value('Hive count'), 10) || 0;
    checks.forEach(check => {
      const key = check.dataset.itemCheck;
      const input = check.closest('[data-quote-item]').querySelector('input[type="number"]');
      if (input.dataset.edited === 'true') return;
      const amount = key === 'hive-kits' ? (value('Adding hives') === 'Yes' ? value('New hives') : '') : (ratios[key] && lower ? ratios[key] * lower : '');
      input.value = amount;
    });
    summary();
  }
  function syncItems() {
    checks.forEach(check => {
      const details = form.querySelector(`[data-item-fields="${check.dataset.itemCheck}"]`);
      details.hidden = !check.checked;
      details.querySelectorAll('input,select,textarea').forEach(input => { input.disabled = !check.checked; });
      cards.filter(card => card.dataset.quoteKey === check.dataset.itemCheck).forEach(card => {
        card.setAttribute('aria-pressed', String(check.checked));
        card.querySelector('[data-toggle-text]').textContent = check.checked ? 'Added to quote' : 'Add to quote';
        card.querySelector('[data-toggle-icon]').textContent = check.checked ? '✓' : '+';
      });
    });
    const count = checked().length;
    page.querySelectorAll('[data-quote-counter]').forEach(el => { el.textContent = `${count} ${count === 1 ? 'item' : 'items'} in your quote`; });
    suggest();
  }
  function toggle(check, source) {
    syncItems();
    track('quote_item_toggle', { item: check.dataset.itemCheck, added: check.checked, source });
  }
  cards.forEach(card => card.addEventListener('click', () => {
    const check = checks.find(item => item.dataset.itemCheck === card.dataset.quoteKey);
    if (!check) return;
    check.checked = !check.checked;
    toggle(check, 'card');
  }));
  checks.forEach(check => check.addEventListener('change', () => toggle(check, 'form')));
  checks.forEach(check => check.closest('[data-quote-item]').querySelector('input[type="number"]').addEventListener('input', event => {
    event.target.dataset.edited = 'true';
    summary();
  }));

  function showStep(index, focus = true) {
    current = index;
    steps.forEach((step, i) => { step.hidden = i !== index; });
    progress.hidden = false;
    progress.textContent = `Step ${index + 1} of 4`;
    back.hidden = index === 0;
    next.hidden = index === 3;
    submit.hidden = index !== 3;
    errors.textContent = '';
    if (focus) steps[index].querySelector('legend').focus();
  }
  function validate(step) {
    const invalid = [...step.querySelectorAll('input,select,textarea')].filter(input => !input.disabled && !input.checkValidity());
    step.querySelectorAll('.ozbee-quote__error').forEach(el => { el.textContent = ''; });
    step.querySelectorAll('[aria-invalid]').forEach(el => el.removeAttribute('aria-invalid'));
    invalid.forEach(input => {
      input.setAttribute('aria-invalid', 'true');
      const error = document.getElementById(input.getAttribute('aria-describedby'));
      if (error) error.textContent = input.validationMessage;
    });
    errors.textContent = invalid.length ? 'Please complete the highlighted fields before continuing.' : '';
    if (invalid.length) invalid[0].focus();
    return !invalid.length;
  }
  next.addEventListener('click', () => {
    if (!validate(steps[current])) return;
    track('quote_step_complete', { step: current + 1 });
    showStep(current + 1);
  });
  back.addEventListener('click', () => showStep(current - 1));
  function selectHives(range, source) {
    radios.forEach(radio => { radio.checked = radio.value === range; });
    heroes.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.heroHives === range)));
    suggest();
    track('quote_hive_count_select', { hive_count: range, source });
  }
  radios.forEach(radio => radio.addEventListener('change', () => selectHives(radio.value, 'form')));
  heroes.forEach(button => button.addEventListener('click', () => {
    selectHives(button.dataset.heroHives, 'hero');
    showStep(0, false);
    form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    steps[0].querySelector('legend').focus({ preventScroll: true });
  }));
  function addingHives() {
    const adding = value('Adding hives') === 'Yes';
    form.querySelector('[data-new-hives]').hidden = !adding;
    field('New hives').disabled = !adding;
    suggest();
  }
  field('Adding hives').addEventListener('change', addingHives);
  field('New hives').addEventListener('input', suggest);
  form.addEventListener('change', summary);
  form.addEventListener('submit', event => {
    if (current < 3) { event.preventDefault(); next.click(); return; }
    for (let i = 0; i < steps.length; i++) {
      if ([...steps[i].querySelectorAll('input,select,textarea')].some(input => !input.disabled && !input.checkValidity())) {
        event.preventDefault(); showStep(i, false); validate(steps[i]); return;
      }
    }
    summary();
    track('quote_step_complete', { step: 4 });
    const delivery = value('Delivery or pickup');
    try {
      sessionStorage.setItem(receiptKey, JSON.stringify({
        hive_count: value('Hive count'), item_count: checked().length,
        delivery_town_type: delivery === 'Deliver' ? 'delivery' : delivery === 'Pick up in Gladstone' ? 'pickup' : 'unsure',
        needed_by: value('Needed by')
      }));
    } catch (_) { /* The request still submits when storage is unavailable. */ }
  });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(entries => {
      const entry = entries[0];
      heroPast = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
      updateSticky();
    }).observe(page.querySelector('[data-quote-hero]'));
    new IntersectionObserver(entries => { formVisible = entries[0].isIntersecting; updateSticky(); }).observe(form);
  }
  form.noValidate = true;
  syncItems();
  addingHives();
  showStep(0, false);
})();
